import { useState } from "react"
import { useDispatch } from "react-redux"
import { useParams, useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

import { resetPassword } from "src/store/user"
import { logMessage } from "src/logging"
import { apiErrorLines, fieldError } from "src/utils/apiErrors"

const ResetPassword = () => {
  const { t } = useTranslation()
  const { uid, token } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [errors, setErrors] = useState(null)
  const [formData, setFormData] = useState({
    password: "",
    repeatPassword: "",
  })
  // Said under the new password (a weak one is 400 `{"password": [...]}` since gamekit 0.11.0, and
  // a mismatch is ours), and not again in the list at the top.
  const passwordProblem = fieldError(errors, "password")

  const handleSubmit = (e) => {
    e.preventDefault()

    if (formData.password !== formData.repeatPassword) {
      setErrors({ password: t("auth.passwordsDoNotMatch") })
      return
    }

    // Success only when the server said so: a refused reset (a weak password, a spent link) used
    // to take the player home with "Your password has been reset" over a password that was not.
    dispatch(resetPassword({ uid, token, password: formData.password }))
      .unwrap()
      .then(() => {
        navigate("/")
        logMessage({ type: "success", text: t("auth.passwordResetSuccess") })
      })
      .catch((refusal) => setErrors(refusal || { detail: t("api.somethingWentWrong") }))
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
    setErrors(null)
  }

  return (
    <form
      style={{
        paddingTop: "15%",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
      onSubmit={handleSubmit}
    >
      <h1>{t("auth.resetPasswordTitle")}</h1>

      {apiErrorLines(errors, { except: ["password"] }).map(({ key, text }) => (
        <p key={key} className="errored-text">
          {text}
        </p>
      ))}
      <br />
      <br />

      <label htmlFor="New password">{t("auth.newPasswordLabel")}</label>
      <input
        type="text"
        id="password"
        name="password"
        className="form-input"
        placeholder={t("auth.newPasswordPlaceholder")}
        value={formData.password}
        onChange={handleInputChange}
        aria-invalid={Boolean(passwordProblem)}
        required
      />
      {passwordProblem && <p className="errored-text">{passwordProblem}</p>}

      <label htmlFor="repeat-password">{t("auth.repeatPasswordLabel")}</label>
      <input
        type="text"
        id="repeatPassword"
        name="repeatPassword"
        className="form-input"
        placeholder={t("auth.repeatPasswordPlaceholder")}
        value={formData.repeatPassword}
        onChange={handleInputChange}
        required
      />

      <br />
      <br />

      <div style={{ display: "flex", justifyContent: "center", gap: "3%" }}>
        <button type="submit">{t("auth.resetPasswordButton")}</button>
      </div>
    </form>
  )
}

export default ResetPassword
